import styled, { createGlobalStyle } from "styled-components";
import Hero from "./components/Hero";
import Projects from "./components/Projects";
import Footer from "./components/Footer";
import LightPillar from "./components/LightPillar";

const GlobalStyle = createGlobalStyle`
  html, body {
    margin: 0;
    font-family: 'Inter', system-ui, sans-serif;
    color: #000;
    background-color: #5227FF;
    overscroll-behavior: none;
    -webkit-overflow-scrolling: touch;
    min-height: 100%;
    padding-bottom: env(safe-area-inset-bottom);
    overflow-x: hidden;
  }
`;

const Frame = styled.div`
  margin: 20px;
  border: 2px solid #ffffff;
  min-height: calc(100vh - 40px);
  padding: 60px 60px 0px 60px;
  box-sizing: border-box;
  position: relative;
  z-index: 2;

  @media (max-width: 768px) {
    padding: 20px 20px 8px 20px;
    margin: 10px;
    max-width: 100%;
    overflow-x: hidden;
  }
`;


const DiffusionLayer = styled.div`
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 1;

  background: rgba(5, 20, 30, 0.35);
  backdrop-filter: blur(6px) saturate(120%);
  -webkit-backdrop-filter: blur(6px) saturate(120%);
`;

const today = new Date();
const isBirthday = today.getMonth() === 3 && today.getDate() === 3;
const isChristmas = today.getMonth() === 11 && today.getDate() === 25;

const App = () => {
  return (
    <>
      <LightPillar
        topColor={isBirthday ? "#FFD700" : isChristmas ? "#FF0000" : "#5227FF"}
        bottomColor={
          isBirthday ? "#FFA500" : isChristmas ? "#008000" : "#FF9FFC"
        }
        intensity={1.0}
        rotationSpeed={1.3}
        glowAmount={0.005}
        pillarWidth={4.5}
        pillarHeight={0.4}
        noiseIntensity={0.7}
        pillarRotation={25}
        interactive={false}
        mixBlendMode="normal"
      />
      <DiffusionLayer />
      <GlobalStyle />

      <Frame>
        <Hero />
        <Projects />
        <Footer />
      </Frame>
    </>
  );
};

export default App;
